import { createContext, useContext } from 'react';
export const MediaGalleryContext = createContext(undefined);
export const useMediaGalleryContext = () => {
    const context = useContext(MediaGalleryContext);
    if (!context) {
        throw new Error('Media Gallery Context not provided');
    }
    return context;
};
